var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 99",
    d: "M0 1.5H2.5V13.5H0",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 101",
    d: "M23.5 13.5L21 13.5L21 1.5L23.5 1.5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 100",
    d: "M3 4H4.5C5.13535 3.25817 5.57812 2.935 6.5 2.5C10.2252 1.64207 12.3947 1.21971 17 1C18.8193 2.15431 19.7529 2.81363 21 4V10.5M12 1.5C12 1.5 9 3.5 8 4.5C7 5.5 12 5.5 13 5C14 4.5 15.5 5.5 15.5 5.5C15.5 5.5 20 9.5 20.5 10.5C21 11.5 20.5 13.5 19 12.5M19 12.5C17.5 11.5 16 10 16 10M19 12.5C20.5 13.5 18.5 15.5 17.5 15C16.5 14.5 14 12 14 12M16.5 14.5C16.5 14.5 16 16 15 16C14 16 13.5 15 13.5 15",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4023",
    x: 5.23735,
    y: 8.06542,
    width: 2.3646,
    height: 3.91498,
    rx: 1.1823,
    transform: "rotate(44.1259 5.23735 8.06542)",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4026",
    x: 12.7461,
    y: 12.3662,
    width: 2.12078,
    height: 4.73647,
    rx: 1.06039,
    transform: "rotate(44.1259 12.7461 12.3662)",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4024",
    x: 8.58305,
    y: 8.54003,
    width: 2.74272,
    height: 5.83973,
    rx: 1.37136,
    transform: "rotate(44.1259 8.58305 8.54003)",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4025",
    x: 10.7725,
    y: 10.207,
    width: 2.74272,
    height: 5.83973,
    rx: 1.37136,
    transform: "rotate(44.1259 10.7725 10.207)",
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryCulture);
export default __webpack_public_path__ + "static/media/project-category-culture.c79dbe54.svg";
export { ForwardRef as ReactComponent };